// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"249a0ef2","513":"3c004a70","703":"ce9ad2de","787":"ac8160a8"}[chunkId] + ".chunk.js";
};